import React, { useState } from "react";
import styles from "./Pagination.module.css";
import TextComponent from "../textComponent/TextComponent";
// import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import { IoIosArrowDropright } from "react-icons/io";
import { IoArrowBackCircleOutline } from "react-icons/io5";

const Pagination = (props) => {

    return (
        <div className={styles.paginationContainer}>
            {props.currentPage !== 1 && <IoArrowBackCircleOutline
                onClick={props?.previousButton} className={styles.paginationIcons} />}
            <TextComponent className={styles.pageText} text={`${props.currentPage} / ${props.totalPages}`} />
            {/* {props?.currentPage !== props.totalPages && <FaArrowRight onClick={props?.nextButton} className={styles.paginationIcons} />} */}

            {props?.currentPage !== props.totalPages &&
                <IoIosArrowDropright
                    onClick={props?.nextButton}
                    className={styles.paginationIcons} />}

        </div>

    );
};

export default Pagination;
